import PrintWeekProgramFlyerContainer from './PrintWeekProgramFlyerContainer'
import PrintFlyerContainer from './PrintFlyerContainer'
import { FLYER, NEWSPAPER, SHOWCASE, SHOWCASEPREVIEWMOVIE, SHOWCASEREDUCED, WEEKPOSTER, WEEKPROGRAMFLYER } from '../../../constants/printType'
import EditPrintTypeContainer from './EditPrintTypeContainer'
import { generatePath } from 'react-router-dom'
import PrintNewspaperContainer from './PrintNewspaperContainer'

const EditPrintContainer = ({match, goBackPath, altGoBackPath}) => {
    const { params, url } = match
    const { printType } = params
    const backPath = printType === 'showcasePreviewMovie' ? altGoBackPath : goBackPath
    const closePagePath = generatePath(backPath, params)

    if (FLYER === printType) {
        return <PrintFlyerContainer
            params={params}
            basicUrl={url}
            closePagePath={closePagePath}
        />
    } else if(SHOWCASE === printType || WEEKPOSTER === printType || SHOWCASEREDUCED === printType || SHOWCASEPREVIEWMOVIE === printType) {
        return <EditPrintTypeContainer
            params={params}
            basicUrl={url}
            closePagePath={closePagePath}
        />
    } else if(WEEKPROGRAMFLYER === printType) {
        return <PrintWeekProgramFlyerContainer
            params={params}
            basicUrl={url}
            closePagePath={closePagePath}
        />
    } else if(NEWSPAPER === printType) {
        return <PrintNewspaperContainer
            params={params}
            basicUrl={url}
            closePagePath={closePagePath}
        />
    }  else {
        return <div>Component under development</div>
    }
}

export default EditPrintContainer